import { useState, useEffect } from "react";
import { getAppConfigFromFirebase, saveAppConfigToFirebase } from "../lib/firebaseService";

export interface DynamicConfigKeys {
  logoText: string;
  logoChar: string;
  abhishekImg: string;
  omkarImg: string;
}

const DEFAULT_CONFIG: DynamicConfigKeys = {
  logoText: "TERALUMAX",
  logoChar: "T",
  abhishekImg: "https://ibb.co/XrjFBXHJ",
  omkarImg: "https://i.ibb.co/ccCnf21t/Whats-App-Image-2026-08-06-at-15-38-39.jpg",
};

export function getDynamicConfig(): DynamicConfigKeys {
  try {
    const text = localStorage.getItem("teralumax_logo_text") || DEFAULT_CONFIG.logoText;
    const char = localStorage.getItem("teralumax_logo_char") || DEFAULT_CONFIG.logoChar;
    const img = localStorage.getItem("teralumax_abhishek_img") || DEFAULT_CONFIG.abhishekImg;
    const omkar = localStorage.getItem("teralumax_omkar_img") || DEFAULT_CONFIG.omkarImg;
    return { logoText: text, logoChar: char, abhishekImg: img, omkarImg: omkar };
  } catch (e) {
    return DEFAULT_CONFIG;
  }
}

export function setDynamicConfig(config: Partial<DynamicConfigKeys>) {
  try {
    if (config.logoText !== undefined) localStorage.setItem("teralumax_logo_text", config.logoText.trim());
    if (config.logoChar !== undefined) localStorage.setItem("teralumax_logo_char", config.logoChar.trim());
    if (config.abhishekImg !== undefined) localStorage.setItem("teralumax_abhishek_img", config.abhishekImg.trim());
    if (config.omkarImg !== undefined) localStorage.setItem("teralumax_omkar_img", config.omkarImg.trim());
    
    // Also update to Firebase Firestore
    const updated = getDynamicConfig();
    saveAppConfigToFirebase(updated).catch(err => console.error("Firebase config sync error", err));

    // Force direct event emission for reactive state updates
    window.dispatchEvent(new Event("teralumax_config_change"));
    window.dispatchEvent(new Event("storage"));
  } catch (e) {
    console.error("Failed to save dynamic config", e);
  }
}

export function useDynamicConfig() {
  const [config, setConfig] = useState<DynamicConfigKeys>(getDynamicConfig());

  useEffect(() => {
    // Background fetch from Firebase
    getAppConfigFromFirebase().then((remoteConfig) => {
      if (remoteConfig) {
        localStorage.setItem("teralumax_logo_text", remoteConfig.logoText);
        localStorage.setItem("teralumax_logo_char", remoteConfig.logoChar);
        localStorage.setItem("teralumax_abhishek_img", remoteConfig.abhishekImg);
        if (remoteConfig.omkarImg) {
          localStorage.setItem("teralumax_omkar_img", remoteConfig.omkarImg);
        }
        setConfig(getDynamicConfig());
        window.dispatchEvent(new Event("teralumax_config_change"));
      }
    }).catch(err => console.error("Firebase config fetch error", err));

    const handleUpdate = () => {
      setConfig(getDynamicConfig());
    };

    window.addEventListener("teralumax_config_change", handleUpdate);
    window.addEventListener("storage", handleUpdate);
    return () => {
      window.removeEventListener("teralumax_config_change", handleUpdate);
      window.removeEventListener("storage", handleUpdate);
    };
  }, []);

  return config;
}

